import { render, staticRenderFns } from "./MenuSettingWidget.vue?vue&type=template&id=73b3e687&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./MenuSettingWidget.vue?vue&type=script&lang=js&"
export * from "./MenuSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./MenuSettingWidget.vue?vue&type=style&index=0&id=73b3e687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b3e687",
  null
  
)

export default component.exports